// CANONICAL COPY (GH #7115). src/constants/obligations/obl-dpia.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-dpia',
  title: 'Conduct Data Protection Impact Assessment where required',
  description:
    'Confirm that a Data Protection Impact Assessment is carried out prior to any processing likely to result in a high risk to the rights and freedoms of natural persons, as required by GDPR Article 35 — in particular large-scale processing of special category data, systematic monitoring of a publicly accessible area, or use of new technologies. The DPIA shall describe the processing and its purposes, assess necessity and proportionality, identify and evaluate risks to data subjects, and document the measures envisaged to mitigate those risks. Where residual high risk remains, the controller shall consult the supervisory authority under Article 36.',
  category: 'risk',
  scfIds: ['SCF-PRV-004'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'dpia-approved-exists',
      description:
        'All registered DPIAs are approved and no assessments are pending (or no high-risk processing has been identified)',
    },
    { type: 'document-published', description: 'DPIA procedure and register are published' },
    { type: 'document-approved', description: 'DPIA procedure has been approved' },
    { type: 'document-within-sla', description: 'DPIA register review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
